import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;

//
//获取周报
export function getWeeklyReport(data) {
  return fetch({
    url: apiUrl + '/api/WeeklyReport/GetWeeklyReport?id='+data,
    method: 'post'
  })
}

export function post(data) {
  return fetch({
    url: apiUrl + '/api/WeeklyReport/Post',
    method: 'post',
    data
  })
}
// export function apiRemoveWeeklyReport(data) {
//   return fetch({
//     url: apiUrl + '/api/WeeklyReport/RemoveWeeklyReport?id='+data,
//     method: 'post'
//   })
// }

export function getWeeklyReportByUser(data) {
  return fetch({
    url: apiUrl + '/api/WeeklyReport/GetWeeklyReportByUser',
    method: 'post',
    data
  })
}

// export function apiGetWeeklyReportListByUser(data) {
//   return fetch({
//     url: apiUrl + '/api/WeeklyReport/GetWeeklyReportListByUser',
//     method: 'post',
//     data
//   })
// }

export function getWeeklyReportList(data) {
  return fetch({
    url: apiUrl + '/api/WeeklyReport/GetWeeklyReportList',
    method: 'post',
    data
  })
}

// export function apiGetWeeklyReportListByOrganization(data) {
//   return fetch({
//     url: apiUrl + '/api/WeeklyReport/GetWeeklyReportListByOrganization',
//     method: 'post',
//     data
//   })
// }

export function getWeeklyReportPostConditionResult(year,weekOfYear) {
  return fetch({
    url: apiUrl + '/api/WeeklyReport/GetWeeklyReportPostConditionResult?year=' + year + '&weekOfYear=' + weekOfYear,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/weeklyReportApi.js